import api from '../../../api'

export default {
  getAPIKeys(context, args) {
    return api.apikeys.find(args.organizationId, args)
  },

  createAPIKey(context, data) {
    const organizationId = data.organizationId
    return api.apikeys.create(organizationId, data)
  },

  deleteAPIKey(context, { organizationId, apiKeyId }) {
    return api.apikeys.delete(organizationId, apiKeyId)
  },
}
